class WorldHelpImagesModalController {

    constructor() {

        $(document).on('slid.bs.carousel', '#carousel-example-generic', function (e) {
            var currentSlide = e.relatedTarget;
            var fullVideo = $(currentSlide).find('.video-fixed-div video');
            var centerVideo = $(currentSlide).find('.help-media-center-background video');
            var title = $(currentSlide).find('.help-preview-title p');

            // Si hay un video en la slide actual, ejecutarlo.
            if (fullVideo.length > 0) {    // Video full
                $('#carousel-example-generic').carousel('pause');
                fullVideo[0].play();
            }
            if (centerVideo.length > 0) {  // Video centrado
                $('#carousel-example-generic').carousel('pause');
                videoBar( centerVideo[0] );
                centerVideo[0].play();

                $(centerVideo).on('ended', function (e) {   // Si tiene video centrado
                    $('#carousel-example-generic').carousel('next');
                });
            }

            if (centerVideo.length === 0 && fullVideo.length > 0) { // Si solo tiene video full
                $(fullVideo).on('ended', function (e) {
                    $('#carousel-example-generic').carousel('next');
                });
                if (title.is(':empty')) {
                    var topBar = $(currentSlide).find("#top-bar");
                    var bottomBar = $(currentSlide).find("#bottom-bar");
                    topBar.show();
                    bottomBar.hide();
                    videoBar(fullVideo[0]);
                }
            }
        });

        // Parar video si se pasa de slide a mitad de su ejecucion
        $(document).on('slide.bs.carousel', '#carousel-example-generic', function (e) {
            var prevSlide = $('.item.active');
            var prevVideo = prevSlide.find('video');

            $(prevVideo).each(function () {
                $(this)[0].pause();
            });
        });

        // Parar todos los videos al mostrar la modal
        $(document).on('show.bs.modal', '#modalHelpLinksImages', function (e) {
            var videos = $(this).find('video');
            var slideIndex = 0;
            $(videos).each(function () {
                // Parar todos los videos menos el primero
                if (slideIndex !== 0) {
                    $(this)[0].pause();
                } else {
                    $(this)[0].play();
                    videoBar($(this)[0]);
                    $(this).on('ended', function (e) {
                        $('#carousel-example-generic').carousel('next');
                    });
                }
                slideIndex++;
            });
        });

        // Parar todos los videos al cerrar la modal
        $(document).on('hidden.bs.modal', '#modalHelpLinksImages', function (e) {
            var videos = $(this).find('video');
            $(videos).each(function () {
                $(this)[0].pause();
            });
            $('#carousel-example-generic').carousel('pause');
        });

        // Barra de progreso del video
        function videoBar(video) {
            $(video).on('loadedmetadata', function () {
                $('.duration').text(video.duration);
            });
            $(video).on('timeupdate', function () {
                var currentPos = video.currentTime;
                var maxduration = video.duration;
                var percentage = 100 * currentPos / maxduration; //in %
                $('.timeBar').css('width', percentage + '%');
            });
        }

        // Cortar el texto
        $("#help-preview-title-text").dotdotdot({
            height: '60px',
            wrap: 'word',
            watch: 'window',
        });

    }
}
